export type EvidenceSection = 'pricing' | 'quotes' | 'benchmarks';

export const evidenceTitles: Record<EvidenceSection, string> = {
  pricing: 'Pricing result',
  quotes: 'Vendor quotes',
  benchmarks: 'Benchmarks',
};
